module.exports = __webpack_public_path__ + "img/pdf.ca3a1273.svg";